(function () {
  window.Shopify = window.Shopify || {};
  Shopify.theme = Shopify.theme || {};
  Shopify.theme.jsAjaxCart = Shopify.theme.jsAjaxCart || {};
  if (typeof Shopify.theme.jsAjaxCart.openCartDrawer === 'function') return;
  Shopify.theme.jsAjaxCart.openCartDrawer = async function () {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) { window.location = routes.cart_url; return; }
    try {
      await window.MKCartSync.refresh();
      drawer.open();
    } catch (error) {
      window.MKCartSync.showError(error);
      window.location = routes.cart_url;
    }
  };
})();
